import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import classNames from 'classnames';
import { service } from '../config';
import { service as commonService } from '../../../common/configs';
import { CHECKLIST_VALUES, HELLO_LEVEL } from '../../WinkConstants';
import { Radio, RadioGroup } from '../../../../library/Radio';
import * as PaymentAction from '../../../../library/payment/PaymentAction';
import TriangleToggle from '../../../common/components/TriangleToggle';
import CheckListBatch from './CheckListBatch';
import CheckListManuallyBatch from './CheckListManuallyBatch';
import { LEVEL_CHOICE, LEVEL_CHOICE_MANUALLY } from '../config/values';

const mapStateToProps = ({ PaymentReducer }) => {
    return {
        selectedStudentInfoList: PaymentReducer.selectedStudentInfoList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedStudentInfoList: (selectedStudentInfoList) =>
            dispatch(
                PaymentAction.setSelectedStudentInfoList(
                    selectedStudentInfoList
                )
            ),
        getSelectedStudentInfo: (student) =>
            dispatch(PaymentAction.getSelectedStudentInfo(student)),
        setCheckList: (checkList) =>
            dispatch(PaymentAction.setCheckList(checkList)),
        initCheckList: () => dispatch(PaymentAction.initCheckList()),
    };
};

class CheckList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            levelChoice: LEVEL_CHOICE.beginner,
            manuallyLevelChoice: LEVEL_CHOICE_MANUALLY.hello,
            choiceOpened: false,
            visitedCheckList: [],
        };

        this.onRadio = this.onRadio.bind(this);
        this.setSelectedStudentInfo = this.setSelectedStudentInfo.bind(this);
        this.onSelectBatch = this.onSelectBatch.bind(this);
        this.onSelectManuallyBatch = this.onSelectManuallyBatch.bind(this);
        this.onClickChoiceToggle = this.onClickChoiceToggle.bind(this);
        this.initLevelChoice = this.initLevelChoice.bind(this);
    }

    componentDidMount() {
        this.setLevel();
    }

    componentDidUpdate(prevProps) {
        const { studentInfo } = this.props;
        if (
            prevProps.studentInfo &&
            prevProps.studentInfo.id !== studentInfo.id
        ) {
            this.setLevel();
        }
    }

    setSelectedStudentInfo = (checkList) => {
        const { studentInfo } = this.props;
        const newSelectedStudentInfoList = { ...studentInfo, checkList };
        const levels = service.getCurrentCheckList(checkList);
        this.props.setCheckList(levels);
        this.props.getSelectedStudentInfo(newSelectedStudentInfoList);
        this.setState((prev) => ({
            visitedCheckList: [
                ...prev.visitedCheckList,
                ...Object.values(checkList).filter(
                    (value) => !prev.visitedCheckList.includes(value)
                ),
            ],
        }));
    };

    initLevelChoice = () => {
        this.setState({
            levelChoice: LEVEL_CHOICE.beginner,
            manuallyLevelChoice: LEVEL_CHOICE_MANUALLY.hello,
            choiceOpened: false,
        });
    };

    setLevel = () => {
        const { studentInfo } = this.props;
        const birthday = studentInfo?.auth_detail?.birthday ?? '';
        const formattedBirthday = birthday
            ? moment(birthday).format('YYYY-MM-DD')
            : null;
        const currentLevel = service.getCurrentLevels(formattedBirthday);
        this.setSelectedStudentInfo(currentLevel);
        this.initLevelChoice();
    };

    onRadio = (value, type) => {
        const { studentInfo } = this.props;
        const checkList = {
            ...studentInfo.checkList,
            [type]: value,
        };

        this.setState({
            levelChoice: LEVEL_CHOICE.manual,
            manuallyLevelChoice: LEVEL_CHOICE_MANUALLY.custom,
        });

        this.setSelectedStudentInfo(checkList);
    };

    renderButtons(item, itemIndex) {
        const { studentInfo } = this.props;
        const { visitedCheckList } = this.state;

        if (!item.buttons) {
            return null;
        }

        return item.buttons.map((button, idx) => {
            const id = `poll-${studentInfo.key}-${itemIndex + 1}-${idx + 1}`;
            const showButtons =
                button.buttons &&
                button.buttons.some((button) =>
                    visitedCheckList.includes(button.value)
                );

            return (
                <li
                    key={idx}
                    className={classNames(
                        'check-list-item',
                        button.notice && 'check-list-notice-item'
                    )}
                >
                    {this.renderButtonItem(id, button, item, { key: id })}

                    {showButtons &&
                        button.buttons.map((childButton, childIdx) => {
                            const id = `poll-${studentInfo.key}-${
                                itemIndex + 1
                            }-${idx + 1}-${childIdx + 1}`;

                            return this.renderButtonItem(
                                id,
                                childButton,
                                item,
                                {
                                    key: id,
                                    className: 'check-list-item-child',
                                }
                            );
                        })}
                </li>
            );
        });
    }

    onClickUpperRadio = (button, item) => {
        const { studentInfo } = this.props;

        const selectedValue = studentInfo.checkList[item.subject];
        const childrenValues = button.buttons
            ? button.buttons.map((button) => button.value)
            : [];
        if (!childrenValues.includes(selectedValue)) {
            this.onRadio(childrenValues[1], item.subject);
        }
    };

    renderButtonItem = (id, button, item, { key, className } = {}) => {
        const { studentInfo } = this.props;
        const { visitedCheckList } = this.state;
        const selectedValue = studentInfo.checkList[item.subject];
        const childrenValues = button.buttons
            ? button.buttons.map((button) => button.value)
            : [];
        const isVisitedOption = visitedCheckList.includes(button.value);
        const showBottom =
            button.comment || (isVisitedOption && button.description);

        return (
            <div key={key} className={className}>
                <div className="check-list-item-radio">
                    {button.notice ? (
                        <div className="check-list-notice-icon" />
                    ) : button.value ? (
                        <Radio id={id} value={button.value} />
                    ) : (
                        <input
                            id={id}
                            type="radio"
                            onClick={() => this.onClickUpperRadio(button, item)}
                            checked={childrenValues.includes(selectedValue)}
                        />
                    )}
                    <label htmlFor={id}>
                        <span className="check-list-level-text">
                            {button.level}
                        </span>
                        <span className="check-list-normal-text">
                            {button.label && `(${button.label})`}
                        </span>
                        <br />
                    </label>
                </div>
                {showBottom && (
                    <div className="check-list-item-desc">
                        {button.comment && (
                            <span className="check-list-comment">
                                {button.comment}
                            </span>
                        )}
                        {button.description &&
                            button.description.length > 0 &&
                            this.renderDescription(button)}
                    </div>
                )}
            </div>
        );
    };

    renderDescription(button) {
        return (
            <div className="check-list-description">
                {button.description.map((levelData, idx) => {
                    return (
                        <div key={idx}>
                            {levelData.label && (
                                <div>
                                    <span style={{ position: 'absolute' }}>
                                        <TriangleToggle
                                            size={6}
                                            style={{ color: '#000000' }}
                                        />
                                    </span>
                                    <p className="check-list-description-label">
                                        {levelData.label}
                                    </p>
                                </div>
                            )}
                            {levelData.desc && (
                                <p className="check-list-description-desc">
                                    {levelData.desc}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    onSelectBatch = (choice) => {
        const { studentInfo } = this.props;
        const birthday = studentInfo?.auth_detail?.birthday ?? '';

        const formattedBirthday = birthday
            ? moment(birthday).format('YYYY-MM-DD')
            : null;
        const currentLevel = service.getCurrentLevels(formattedBirthday);
        const currentAgeLevel = service.getCurrentAgeLevels(formattedBirthday);

        const newState = {
            levelChoice: choice,
            manuallyLevelChoice:
                currentAgeLevel === 'HELLO'
                    ? LEVEL_CHOICE_MANUALLY.hello
                    : LEVEL_CHOICE_MANUALLY.custom,
        };

        if (LEVEL_CHOICE.manual === choice && currentAgeLevel !== 'HELLO') {
            newState.choiceOpened = true;
        }

        this.setState(newState);
        this.setSelectedStudentInfo(currentLevel);
    };

    onSelectManuallyBatch = (choice) => {
        const { studentInfo } = this.props;
        const birthday = studentInfo?.auth_detail?.birthday ?? '';

        let currentLevel = {};

        // 안녕 단계 선택
        if (LEVEL_CHOICE_MANUALLY.hello === choice) {
            currentLevel = HELLO_LEVEL;
        } else {
            // 직접 입력 선택
            const currentAgeLevel = service.getCurrentAgeLevels(birthday);

            // 30~38개월이 아닌 경우 추천 단계, 30~38개월인 경우 선택할 수 있는 옵션이 없어서 직접 선택해야 한다
            if (currentAgeLevel !== 'HELLO') {
                currentLevel = service.getCurrentLevels(birthday);
            }
        }

        const newState = {
            manuallyLevelChoice: choice,
        };

        if (LEVEL_CHOICE_MANUALLY.custom === choice) {
            newState.choiceOpened = true;
        }

        this.setState(newState);
        this.setSelectedStudentInfo(currentLevel);
    };

    onClickChoiceToggle = () => {
        this.setState((prevState) => ({
            choiceOpened: !prevState.choiceOpened,
        }));
    };

    renderCheckList = () => {
        const { studentInfo } = this.props;

        return CHECKLIST_VALUES.map((item, itemIndex) => {
            const description = item?.description ?? {};
            return (
                <li key={itemIndex} className="level-check-list-container">
                    <div className="level-check-list-group">
                        <div className="level-check-list-title">
                            {item.title}
                        </div>
                        <div className="level-check-list-body">
                            {description.top && (
                                <div
                                    className="check-list-top-description no-bg"
                                    style={{ marginBottom: 20 }}
                                >
                                    {description.top}
                                </div>
                            )}
                            <RadioGroup
                                name={`${studentInfo.key}-${item.name}`}
                                selectedValue={
                                    studentInfo.checkList[item.subject]
                                }
                                onChange={(value) => {
                                    this.onRadio(value, item.subject);
                                }}
                            >
                                <ul className={'radio-list-col'}>
                                    {this.renderButtons(item, itemIndex)}
                                </ul>
                            </RadioGroup>
                            {description.bottom && (
                                <small className="bottom-description">
                                    {description.bottom}
                                </small>
                            )}
                        </div>
                    </div>
                </li>
            );
        });
    };

    render() {
        const { levelChoice, manuallyLevelChoice, choiceOpened } = this.state;
        const showManuallyCheckList = levelChoice === LEVEL_CHOICE.manual;
        const showCustomLevelCheckList =
            showManuallyCheckList &&
            manuallyLevelChoice === LEVEL_CHOICE_MANUALLY.custom;

        return (
            <div className="wink-apply-check-list-container">
                <CheckListBatch
                    onSelect={this.onSelectBatch}
                    levelChoice={levelChoice}
                />
                {showManuallyCheckList && (
                    <CheckListManuallyBatch
                        onSelect={this.onSelectManuallyBatch}
                        levelChoice={manuallyLevelChoice}
                    />
                )}
                {showCustomLevelCheckList && (
                    <section className="check-wrap">
                        <div className="hgroup">
                            <h2 className="no-line title">상세 보기</h2>
                            <div
                                className={`agreement-collapse ${
                                    choiceOpened ? 'active' : ''
                                }`}
                                onClick={this.onClickChoiceToggle}
                            />
                        </div>
                        {choiceOpened && (
                            <div style={{ marginTop: 10 }}>
                                <div className="level-check-list">
                                    <ul>{this.renderCheckList()}</ul>
                                </div>
                            </div>
                        )}
                    </section>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckList);
